// A button that asks once before it acts. The first click shows the
// question on the button for a time, in crimson. A second click while it
// shows does the action. With nothing to ask, the first click does it.
// The question is one word for every such button. Garrett, 2026-10-14: "just
// say 'SURE?'". It was a question for each action, such as "End this
// match?", and it did not fit the button.

import { NEW_MATCH_CONFIRM_MS } from '../constants';
import { el } from '../lib/dom';

const ASKING_CLASS = 'button--asking';
/** Plain words, not final copy. */
const QUESTION = 'Sure?';

export type AskingButtonOptions = {
  label: string;
  /** False when the action needs no question now. */
  mustAsk: () => boolean;
  onConfirm: () => void;
  /** What the button shows while it does not ask, when that is more than the label. */
  content?: () => Node[];
  className?: string;
};

export const createAskingButton = (options: AskingButtonOptions): HTMLButtonElement => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const rest = (): Node[] => options.content?.() ?? [document.createTextNode(options.label)];
  const disarm = (): void => {
    if (timer) clearTimeout(timer);
    timer = null;
    button.replaceChildren(...rest());
    button.classList.remove(ASKING_CLASS);
  };
  const button = el('button', {
    className: `button button--pass-through${options.className ? ` ${options.className}` : ''}`,
    type: 'button',
    onclick: () => {
      if (options.mustAsk() && timer === null) {
        button.textContent = QUESTION;
        button.classList.add(ASKING_CLASS);
        timer = setTimeout(disarm, NEW_MATCH_CONFIRM_MS);
        return;
      }
      disarm();
      options.onConfirm();
    },
  });
  button.replaceChildren(...rest());
  return button;
};
